import { apiFetch, apiPost, apiPut, apiDelete } from '@/lib/api-client';

export async function getFootprints() {
  try {
    return await apiFetch<any[]>('/api/footprints');
  } catch {
    return [];
  }
}

export async function getFootprintById(id: string) {
  try {
    return await apiFetch<any>(`/api/footprints/${id}`);
  } catch {
    return null;
  }
}

export async function createFootprint(data: any) {
  return apiPost('/api/footprints', data);
}

export async function updateFootprint(id: string, data: any) {
  return apiPut(`/api/footprints/${id}`, data);
}

export async function deleteFootprint(id: string) {
  return apiDelete(`/api/footprints/${id}`);
}
